import { DesigntimeComponent } from './DesigntimeComponent.js'
import { LiquidString } from '../common/LiquidString.js'
import * as $ from 'jquery';

class Redirect extends DesigntimeComponent {
    static staticName = "Redirect";
    static staticId = "redirect";
    hasRuntimeView = true;

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {
            header: new LiquidString("Default **header** text", `${this.id}_header`),
            text: new LiquidString("Default text", `${this.id}_text`),
            buttontext: { value: "Next" },
            imageurl: { value: "intro_game_changer.png", dontTranslate: true },
            imageclass: { value: "sid-image-circle", dontTranslate: true },
            url: { value: "/dashboard" }
        };
    }

    getRuntimeView(context) {
        let $view = $("<div></div>");
        if (this.values.imageurl.value) {
            var $imagebox = $("<div class='sid-question-image'></div>");
            $imagebox.append($("<img class='" + this.values.imageclass.value + "' src='" + context.getContentUrl() + this.values.imageurl.value + "'>"));
            $view.append($imagebox);
        }
        var textbox = $("<div class='sid-question-text'></div>");

        textbox.append(this.values.header.getTag("h3"));
        textbox.append(this.values.text.getTag("p"));
        $view.append(textbox);


        if (false) {
            this.eventBroker.fire("nexButtonClickedEvent", this.nodeId);
        }

        return $view;
    }

    onNodeShown(nodeId) {
        window.location.href = this.values.url.value;
    }
}

export { Redirect }
